export default "__VITE_PUBLIC_ASSET__c4e6315a__"